var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai"},[_c('button',{on:{"click":function($event){_vm.comName='UserName'}}},[_vm._v("账号密码填写")]),_c('button',{on:{"click":function($event){_vm.comName = 'UserInfo'}}},[_vm._v("个人信息填写")]),_c('div',[_c(_vm.comName,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }